import { toAbsoluteUrl } from "@/lib/absolute-url";
import type { FeaturePageRenderModel } from "@garimpa/api/featurePages/types";

export function featurePageSocialImage(page: FeaturePageRenderModel) {
  const image = page.seo.image;
  if (!image) {
    return {
      imageUrl: null,
      image: { width: undefined, height: undefined, alt: page.seo.socialTitle },
    };
  }

  return {
    imageUrl: toAbsoluteUrl(image.url),
    image: {
      width: image.width?.toString(),
      height: image.height?.toString(),
      alt: image.alt ?? page.seo.socialTitle,
    },
  };
}
